import { observable, action, computed } from 'mobx'

import { BlockModel } from '@client/components/Block/model'
import { defaultSettings } from './constants'
import { MIN_WIDTH } from '@client/components/Block/constants'

export default class SubmitButtonModel extends BlockModel {
  constructor(data = {}, editor) {
    super(data)

    this.editor = editor

    this.settings.set({
      ...{
        text: defaultSettings.text,
      },
      ...data.settings,
    })
  }

  @observable containerDimensions = { width: 0, height: 0 }

  @action setContainerDimensions = (obj) => {
    if (!obj || (obj && !obj.width) || (obj && obj.width < MIN_WIDTH)) {
      return
    }
    this.containerDimensions = obj
    if (
      this.editor?.viewMode !== 'mobile' &&
      this.settings.values.width > obj.width
    ) {
      // As a string: that is what every stored payload holds and what the
      // other blocks write, so a number here would flip the type and dirty
      // the document on first measurement. FE-1359.
      this.settings.set({ width: obj.width.toString() })
    }
  }

  @computed get allColors() {
    const s = this.settings.values
    const colors = [s.backgroundColor, s.borderColor, s.textColor]

    return Array.from(new Set(colors.filter(Boolean)))
  }
}

export const NULL = new SubmitButtonModel()
